<template lang="pug">
#album
  header.album__header
    button.album__back(@click="$router.back('/')")
      fa(icon="angle-left")
      span &nbsp; Back to Home
  h2.title.is-2.album__title {{ album.title }}
  layoutContainer
    .photos
      .photo(v-for="photo in photos" :style="{ backgroundImage: `url('${photo.url}')` }")
</template>

<style lang="sass" scoped>
@import '../assets/style'

.album__header
  max-width: 900px
  padding: 0 $pad
  margin-left: auto
  margin-right: auto
.album__title
  padding: $pad*2 $pad
  max-width: 900px
  margin-left: auto
  margin-right: auto

  color: #00b8e6

.photos
  display: flex
  flex-wrap: wrap

  padding: $pad*5 $pad
  background-image: linear-gradient(#00b8e6, #e0e0d1)
  border-radius: 8px
  box-shadow: 20px 10px 50px 30px #e0e0d1

.photo
  flex-grow: 1
  width: 18rem
  height: 14rem
  border: 5px solid $color-background-light
  padding: $pad*2 $pad

  margin: 5px

  float: left
  background-size: cover
  background-position: center
  cursor: pointer

.album__back
  margin-top: $pad
  background-color: transparent
  border: 1px solid $color-layout-border
</style>


<script>
import layoutContainer from '@/components/layoutContainer.vue';
import {db} from '../firebase';

import { type } from 'os';
export default {
  components: {
    layoutContainer,
  },
  data(){
    return{
      album: {},
      photos: [],
    }
  },
  mounted() {

    window.scrollTo(0, 0);

    db.collection('gallery')
    .doc(this.$route.params.id)
    .get()
    .then(doc => {
      this.album = doc.data()
    })


    db.collection('gallery')
    .doc(this.$route.params.id)
    .collection('photos')
    .get()
    .then(snapshot => {
      var photos = snapshot.docs.map(doc => {
         // Get document data object
            var docObject = doc.data();
            // Add id key to data object
            docObject.id = doc.id;
            // Return the new data object
            return docObject;
      });

      this.photos = photos;
    })
    
  }
}
</script>
